import { mediaItems } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-8 md:mb-12">
            <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-2">
              精彩视频
            </h2>
            <p className="text-sm text-foreground-500">漫画PV、作者访谈、新番导视等精彩视频内容</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {mediaItems.map((item) => (
              <div
                key={item.id}
                className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative aspect-video overflow-hidden bg-background-200">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-black/20 flex items-center justify-center group-hover:bg-black/30 transition-colors">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90">
                      <i className="ri-play-fill text-primary-600 text-xl ml-0.5"></i>
                    </div>
                  </div>
                  <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-background-50 text-xs font-medium rounded">
                    {item.duration}
                  </div>
                </div>
                <div className="p-3 md:p-4">
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1 line-clamp-1">{item.title}</h3>
                  <div className="flex items-center gap-2 text-xs text-foreground-500">
                    <i className="ri-eye-line"></i>
                    <span>{item.views}次播放</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}